import React from 'react';
import { sprintf } from 'sprintf-js';

import { Box } from 'components/Box';
import { AvatarImage } from 'components/Image';
import { ConditionalLink } from 'components/Link';
import Text, { Body, H4 } from 'components/Text';
import { colors } from 'theme';
import { humanDateTime } from 'utils/date';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const Byline = ({
  slug,
  name,
  imageHandle,
  homePageUrl,
  postedDate,
  showDate,
  small,
}: {
  slug?: string;
  name?: string;
  imageHandle?: string | null | undefined;
  homePageUrl?: string;
  postedDate: string;
  showDate: boolean;
  small?: boolean;
}) => (
  <Box classes={['flex', 'align-center']} data-qa-id="byline" flex="2">
    {imageHandle && (
      <AvatarImage
        data-qa-id="byline-image"
        alt={sprintf(getText('%(name)s profile image'), {
          name,
        })}
        handle={imageHandle}
        width={60}
        round
        mr={3}
      />
    )}
    <Box>
      {name && (
        <H4 data-qa-id="author-name" m={0} lineHeight={1}>
          <ConditionalLink
            data-qa-id="author-name-link"
            link={
              homePageUrl && slug
                ? `/${homePageUrl}?author.slug=${slug}&pq=`
                : ''
            }
          >
            <Body styleAs={small && 'bodySmall'} lineHeight={1.33}>
              {name}
            </Body>
          </ConditionalLink>
        </H4>
      )}
      {showDate && (
        <Text
          tag="time"
          // @ts-expect-error Fix type
          dateTime={postedDate}
          color={colors.battleshipGrey}
          styleAs={small ? 'bodyMicro' : 'bodySmall'}
        >
          {humanDateTime(postedDate)}
        </Text>
      )}
    </Box>
  </Box>
);

// eslint-disable-next-line import/no-default-export
export default Byline;
